const Card = (props) => {
  const { owner, full_name, description } = props;
  return (
    <div style={{ margin: "1em" }}>
      <img src={owner.avatar_url} style={{ width: "50px" }} alt="avatar" />
      <div>
        <div style={{ fontWeight: "bold" }}>{full_name}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};

export default Card;
